import {
  CREATE_TECHNOLOGY,
  DELETE_TECHNOLOGY,
  EDIT_TECHNOLOGY,
  TECHNOLOGY_LIST,
} from "./apiRoutes";
import { authData } from "./Service";

export const listOfTechnologyApi = async (data) => {
  const response = await authData.post(TECHNOLOGY_LIST, data);
  return response?.data;
};

export const CreateTechnologyApi = async (data) => {
  const response = await authData.post(CREATE_TECHNOLOGY, data);
  return response?.data;
};

export const EditTechnologyApi = async (data) => {
  const response = await authData.put(EDIT_TECHNOLOGY, data);
  return response?.data;
};

export const DeleteTechnologyApi = async (id) => {
  const response = await authData.delete(`${DELETE_TECHNOLOGY}${id}`);
  return response?.data;
};
